import { PickerType } from '../date-picker/constants'
import Picker from '../date-picker/Picker'

export default {
  name: 'KTimePicker',
  mixins: [Picker],
  props: {
    precision: {
      validator: value => ['hour', 'minute', 'second'].indexOf(value) !== -1,
      default: 'minute',
    },
    type: { // 类型，
      validator: value => {
        return [PickerType.Time].indexOf(value) !== -1
      },
      default: 'time',
    },
  },
}
